import React,{useState, useEffect, useRef} from "react";
import ManagePlans from "./managePlans";
import '../style.scss';
import { startLoader, stopLoader } from "../../../lib/utils";
import { createMembershipPlan, updateMembershipPlan } from "../helper/api";
import {isAuthenticated} from "../../../auth/index";
import Toast from '../../../lib/toast';
import { getBranch } from "../../gyms/helper/api";
import { isEqual } from "lodash";

const ManageMembership = (props) => {

  const [isButtonLock,setButtonLock] = useState(false);
  const branchInfo = useRef(null);
  const [copymembershipPlan,setCopymembershipPlan] = useState('');
  const [membershipPlan,setMembershipPlan] = useState({
    membershipPlanId:"",
    name:"",
    type: '',
    activities:[],
    planTimingType:"regular_time",
    packages:[{
      durationType:"",
      duration:0,
      sessions:0,
      rackRate:0,
      basePrice:0,
      isUpgradePlan:false,
      upgradeDurationType:"",
      upgradeDuration:0
    }]
  })

  const {user,token} = isAuthenticated();


  const updateMembershipData = newData =>{

  const keys =[ 'name', 'type', 'activities', 'planTimingType', 'packages' ];
  const pkeys = [ "basePrice","duration","durationType","isUpgradePlan","rackRate","sessions", "poolCharges", "poolMembersAllowed", "upgradeDuration","upgradeDurationType"]
    

    let copy = {};
    for(const key of keys){
      if(key == "packages"){
        copy['packages'] = [];
        for(const p of membershipPlan[key]){
          let pObj={};
          for(const pKey of pkeys){
            pObj[pKey] = p[pKey] == null?"":p[pKey];
          }
          copy['packages'].push(pObj);
        }
      }else{
        copy[key] = membershipPlan[key];
      }

    }

    let newObj = {};

    for(const key of keys){
      newObj[key] = newData[key];
    }

    newData = {
      ...newObj
    };


    let membershipplan={...copy};
    if(newData.name) membershipplan.name = newData.name;
    if(newData.type) membershipplan.type = newData.type;
    if(newData.activities) membershipplan.activities = [newData.activities];
    if(newData.planTimingType) membershipplan.planTimingType=newData.planTimingType;
    if(newData.packages && newData.packages.length){
       membershipplan.packages= newData.packages.map(pkg=>{
        return {
          durationType:pkg.durationType,
          duration:pkg.duration,
          sessions:pkg.session,
          rackRate:pkg.rackRate,
          basePrice:pkg.basePrice,
          isUpgradePlan:pkg.upgradePlan,
          upgradeDurationType:pkg.upgradeDurationType,
          upgradeDuration:pkg.upgradeDuration,
          ...(pkg.poolMembership && { poolMembership:pkg.poolMembership, poolCharges:pkg.poolCharges })
        }
       })
    }
    
    // [
    //   {
    //     durationType:newData.packages[0].durationType,
    //     duration:newData.packages[0].duration,
    //     sessions:newData.packages[0].session,
    //     rackRate:newData.packages[0].rackRate,
    //     basePrice:newData.packages[0].basePrice,
    //     isUpgradePlan:newData.packages[0].upgradePlan,
    //     upgradeDurationType:newData.packages[0].upgradeDurationType,
    //     upgradeDuration:newData.packages[0].upgradeDuration,
    //     ...(newData.packages[0].poolMembership && { poolMembership:newData.packages[0].poolMembership, poolCharges:newData.packages[0].poolCharges })
    //   }
    // ];

    console.log("Hello World",membershipplan)

    if(isEqual(membershipplan,copy)) return;

    setMembershipPlan({
      ...membershipPlan,
      ...membershipplan
    })


    if (
      membershipplan.name &&
      membershipplan.packages &&
      membershipplan.packages.length &&
      membershipplan.type &&
      membershipplan.packages[0].duration &&
      membershipplan.packages[0].durationType &&
      membershipplan.packages[0].rackRate &&
      membershipplan.packages[0].sessions && 
      membershipplan.packages[0].basePrice &&
      (membershipplan.packages[0].isUpgradePlan
        ? (membershipplan.packages[0].upgradeDuration && membershipplan.packages[0].upgradeDurationType)
        : true)
    ) {
      setButtonLock(false);
    } else {
      setButtonLock(true);
    }

  }


  const CreateMemberShipPlan = async event =>{
    event.preventDefault();
    if(!branchInfo.current){
      new Toast({
          type:"error",
          message:"Gym not selected",
          duration:3000
      })
    }
    try{

    startLoader()
    setButtonLock(true)

    console.log(membershipPlan)

    const payload={
      ...membershipPlan,
      branchId:branchInfo.current._id,
      gymId:branchInfo.current.gymId
    };
    
    const response = await createMembershipPlan(user._id,token,payload);

    if(response.error){
      new Toast({
        type:"error",
        message:response.error,
        duration:3000
      })
    }else{
      new Toast({
        type:"success",
        message:"Membership plan created successfully",
        duration:3000
      })
      props.handleCloseModal();
    }



    }catch(error){
      new Toast({
        type:"error",
        message:error,
        duration:3000
      })
    }
    stopLoader()
    setButtonLock(false);

  }

  const UpdateMembershipPlan = async event=>{
    event.preventDefault()
    if(!branchInfo.current){
      new Toast({
          type:"error",
          message:"Gym not selected",
          duration:3000
      })
    }
    try{
      const membershipPlanId = membershipPlan.membershipPlanId;
      const payload = {
        ...membershipPlan,
        branchId:branchInfo.current._id,
        gymId:branchInfo.current.gymId
      }

      // if(membershipPlan?.packages){
      //   new Toast({
      //     type:"warning",
      //     message:"Membership plan with multiple package can't be edited",
      //     duration:3000
      //   })
      //   return;
      // }
      

      delete payload.membershipPlanId;

      const response = await updateMembershipPlan(user._id,token,membershipPlanId,payload);

      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
      }else{
        new Toast({
          type:"success",
          message:"Membership plan updated successfully",
          duration:3000
        })

        props.handleCloseModal();
        if(props.reload) props.reload()
      }

    }catch(error){
      new Toast({
        type:"error",
        message:error,
        duration:3000
      })
    }
    event.stopPropagation();
  }


  useEffect(async ()=>{
    if(props.membershipPlan){
    let membershipplan = {};
    membershipplan={
      ...membershipPlan,
      membershipPlanId:props.membershipPlan._id,
      ...props.membershipPlan
    };
  
    setMembershipPlan({...membershipplan})
    setCopymembershipPlan({...membershipplan});
  }

  if(branchInfo.current && !branchInfo.current){
    branchInfo.current=props.selectedGym;
  }

  if(!branchInfo.current){
    const branchId = localStorage.getItem("branchId");
    if(branchId){
      const response = await getBranch(user._id,token,branchId);
      if(!response.error){
        branchInfo.current = response;
      }
    }
    
  }
    
  },[props]);

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="membership-modal-container flex-item">
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex flex-item'>
                <svg className='flex-item m-r-8' width="28" height="28" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.7077 3.62742C15.1398 3.62581 14.5356 3.625 13.8952 3.625C8.48427 3.625 5.7776 3.625 4.09681 5.30579C2.41602 6.98658 2.41602 9.69204 2.41602 15.1042C2.41602 20.5151 2.41602 23.2217 4.09681 24.9025C5.7776 26.5833 8.48306 26.5833 13.8952 26.5833C19.3061 26.5833 22.0128 26.5833 23.6936 24.9025C25.3743 23.2217 25.3743 20.5163 25.3743 15.1042C25.3743 14.4638 25.3735 13.8596 25.3719 13.2917" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.45703 21.1452C11.2749 18.1944 16.484 18.0555 19.332 21.1452M22.3529 2.41602L22.6646 3.25822C23.073 4.36264 23.2772 4.91485 23.6796 5.31722C24.0832 5.72081 24.6354 5.92502 25.7398 6.33343L26.582 6.64518L25.7398 6.95693C24.6354 7.36535 24.0832 7.56956 23.6808 7.97193C23.2772 8.37552 23.073 8.92772 22.6646 10.0321L22.3529 10.8743L22.0411 10.0321C21.6327 8.92772 21.4285 8.37552 21.0261 7.97314C20.6225 7.56956 20.0703 7.36535 18.9659 6.95693L18.1237 6.64518L18.9659 6.33343C20.0703 5.92502 20.6225 5.72081 21.0249 5.31843C21.4285 4.91485 21.6327 4.36264 22.0411 3.25822L22.3529 2.41602ZM16.9093 12.0827C16.9093 13.7502 15.556 15.1035 13.8849 15.1035C13.4878 15.1042 13.0944 15.0265 12.7274 14.875C12.3603 14.7234 12.0267 14.501 11.7457 14.2204C11.4647 13.9399 11.2417 13.6066 11.0896 13.2398C10.9375 12.873 10.8592 12.4798 10.8592 12.0827C10.8592 10.4152 12.2125 9.06185 13.8849 9.06185C14.2819 9.06137 14.6751 9.13916 15.042 9.29076C15.4089 9.44235 15.7424 9.66479 16.0233 9.94535C16.3042 10.2259 16.527 10.5591 16.679 10.9258C16.8311 11.2926 16.9093 11.6857 16.9093 12.0827Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item modal-header-text color-white">Membership Plan</p>
              </div>
              <div className="flex-item">
                {/*TODO: packages, plan, campaign*/}
                {/* <div className="flex-item d-flex w-full bg-white p-l-12 p-r-8 m-r-16" style={{height:"30px", borderRadius:"12px"}}>
                  <p className="flex-item color-red font-weight-700 m-r-16 fs-16">Plan</p>
                  <svg className="flex-item" width="15" height="15" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5.7619 6L11 1" stroke="#6d6d6d" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </div> */}
                <div onClick={()=>props.handleCloseModal()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                  </svg>
                </div>
              </div>
            </div>
          )
        }
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "100%" : "100%"}}>
          <ManagePlans membershipPlan={copymembershipPlan}  updateMembershipData={updateMembershipData}/>
        </div>

        <div className="w-full" style={{zIndex:100, position:"absolute", bottom:0, padding:"12px", background : "#f4f4f4", borderRadius:"0 0 20px 20px"}}>
          <div onClick={isButtonLock?null:copymembershipPlan.membershipPlanId?UpdateMembershipPlan:CreateMemberShipPlan} className={`global-button-container ${isButtonLock?"global-button-container-inactive":"global-button-container-active"} d-flex flex-item`} style={{borderRadius:"20px", height:"40px",pointerEvents:isButtonLock?"none":"auto"}}>
            <p className="flex-item" style={{fontSize:'16px'}}>{copymembershipPlan.membershipPlanId?"Update":"Create"}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageMembership;